module.exports = __webpack_public_path__ + "img/cards1_front171.76ce5891.png";